import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getAllGroups,
  // getEstateDetailsByGroupID,
  getBudgetCodeDetails,
  GetSKUCategoryDetails,
  GetSKUCategoryNamesByID,
  DeleteSKUCategoryDetails,
  saveDetails,
  GetDetailsBySKUCategoryID,
  UpdateSKUCategoryDetails,
  getAllFactoriesByGroupID,
  findExistsRecord 
}

async function getAllGroups() {
  let response = await CommonGet('/api/Factory/GetAllActiveGroups', null);
  let groupArray = []
  for (let item of Object.entries(response.data)) {
    groupArray[item[1]["groupID"]] = item[1]["groupName"]
  }
  return groupArray;
}

async function getAllFactoriesByGroupID(groupID) {
  let response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  let factoryArray = []
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
  }
  return factoryArray;
}

async function getBudgetCodeDetails() {
  let response = await CommonGet('/api/BudgetCode/GetAllBudgetCodes',null);
  let budgetCodeArray = [];
  for (let item of Object.entries(response.data)) {
    budgetCodeArray[item[1]["budgetCodeID"]] = item[1]["budgetCodeName"];
  }
  budgetCodeArray[0] = '--Select Account Code--';
  return budgetCodeArray;
};

async function GetSKUCategoryNamesByID(budgetCodeID,groupID,factoryID) {
  let response = await CommonGet('/api/SKUCategory/GetSKUCategoryNamesByEstateIDBudgetCodeID', 'budgetCodeID=' + budgetCodeID +'&groupID=' + groupID +'&factoryID=' + factoryID);
  let categoryArray = [];
  for (let item of response.data) {
    categoryArray.push({
      skuCategoryID: item.skuCategoryID,
      skuCategoryName: item.skuCategoryName
    });
  }
  return categoryArray;
}

async function GetSKUCategoryDetails(model) {
  const response = await CommonPost('/api/SKUCategory/GetSKUCategoryDetails', null, model);
  return response;
};

async function findExistsRecord(model) {
  const response = await CommonPost('/api/SKUCategory/FindExistsRecord', null, model);
  return response;
};

async function saveDetails(model) {
  const response = await CommonPost('/api/SKUCategory/SaveSKUCategoryDetails', null, model);
  return response;
};


async function DeleteSKUCategoryDetails(model) {
  const response = await CommonPost('/api/SKUCategory/DeleteSKUCategoryDetails', null, model)
  return response;
}

async function GetDetailsBySKUCategoryID(skuCategoryID) {
  let response = await CommonPost('/api/SKUCategory/GetDetailsBySKUCategoryID', "SKUCategoryID=" + parseInt(skuCategoryID))
  return response.data;
}

async function UpdateSKUCategoryDetails(skuDetails) {
  const response = await CommonPost('/api/SKUCategory/UpdateSKUCategoryDetails', null, skuDetails);
  return response;
}






